import { usePageFilters } from 'customHooks/usePageFilters';
import { AssetListFilters } from 'components/common/types/AssetList.types';
import AssetTable from './AssetTable';
import Filters from './Filters';

const AssetContent: React.FC = () => {
  const { filters } = usePageFilters<AssetListFilters>();

  return (
    <>
      <Filters />
      <AssetTable filters={filters as AssetListFilters} />
    </>
  );
};

export default AssetContent;
